// @flow
export const filterId: 'studentSubsidyType' = 'studentSubsidyType';
